import { StandardEvents } from '@shopify/events';

class PdpObjectSizeDialog extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    this.#resetSelection();
    this.#abortController.abort();
    this.#abortController = new AbortController();
    this.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#abortController.signal,
    });
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #resetSelection() {
    const requiresSelection = Array.from(
      this.querySelectorAll('.variant-picker fieldset, .variant-picker select')
    ).some((control) => control.querySelectorAll('input, option').length > 1);

    if (!requiresSelection) {
      this.setAttribute('data-size-selected', '');
      return;
    }

    for (const input of this.querySelectorAll('.variant-picker input:checked')) {
      input.checked = false;
      input.dataset.currentChecked = 'false';
    }

    const addToCartButton = this.querySelector('[ref="addToCartButton"]');
    if (addToCartButton instanceof HTMLButtonElement) addToCartButton.disabled = true;
    this.removeAttribute('data-size-selected');
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || !this.contains(event.target) || !event.promise) return;

    this.removeAttribute('data-size-selected');
    event.promise
      .then(({ detail }) => {
        if (detail?.resource?.available === true) this.setAttribute('data-size-selected', '');
      })
      .catch(() => {});
  };

  #handleCartUpdate = (event) => {
    if (!(event.target instanceof Element) || !this.contains(event.target) || !event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (detail?.didError) return;
        this.querySelector('theme-drawer')?.close();
      })
      .catch(() => {});
  };
}

if (!customElements.get('pdp-object-size-dialog')) {
  customElements.define('pdp-object-size-dialog', PdpObjectSizeDialog);
}
